<template>
  <router-view />
</template>

<script>
export default {
  name: 'OrdersWrapper',
};
</script>
